import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useToasts } from "react-toast-notifications";
import { requestCanceller } from "../../../service/axiosCancelToken";
import { deletePlaceCategoryById, getAllPlaceCategories } from "../../../service/placeCategoryService";
import DashboardContext from "../../context/dashboardContext";
import DeleteModal from "../../shared/DeleteModal";
import LoadingSpinner from "../../shared/LoadingSpinner";
import './PlaceCategories.css'


const PlaceCategories = () => {
    const [placeCategories, setPlaceCategories] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState();

    const dashContext = useContext(DashboardContext);

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllCategories = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getAllPlaceCategories({cancelToken: cancelRequest.signal});
                if(status === 201)
                setPlaceCategories(data.placeCategories)
                setIsLoading(false);
            } catch (err) {

            }
        }
        fetchAllCategories();
        return () => {
			cancelRequest.cancel();
        }
    }, []);

    const history = useHistory();
    const { addToast } = useToasts();

    const deleteHandler = async (placeCategoryID) => {
        try {
            setIsLoading(true);
            const { status } = await deletePlaceCategoryById(placeCategoryID);
            if(status === 201){
                addToast("دسته بندی با موفقیت حذف شد", {
                    appearance: 'success',
                    autoDismiss: true,
                })
                dashContext.setPlaceCategoryCount(dashContext.placeCategoryCount - 1);
                let allItems = [...placeCategories];
                let filtered = allItems.filter(item => item._id !== placeCategoryID);
                setPlaceCategories(filtered);
                setIsLoading(false);
            }
        } catch (err) {
            if(err.response && err.response.status === 401){
                addToast("عدم دسترسی مجاز", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/login');
            }
			else if(err.response && err.response.status === 404){
                addToast("دسته بندی مورد نظر وجود ندارد !", {
                    appearance: 'error',
                    autoDismiss: true,
                })
                history.replace('/dashboard/questions')
            }
        }
    }

    useEffect(() => {
        if(deleteId)
        setShowDeleteDialog(true);
        else
        setShowDeleteDialog(false);
    },[deleteId])

    return (
        <React.Fragment>
            {
                (isLoading || !placeCategories) ? 
                <div style={{ height: '70vh' }} className="d-flex">
                    <div className="text-center align-self-center mx-auto">
                        <LoadingSpinner />
                    </div>
                </div>
                :
                <div className="category-layer px-sm-5 px-md-5 ">
                    <header>
                        <h1>
                             دسته بندی مکان ها
                        </h1>
                        <DeleteModal
                            show={showDeleteDialog}
                            closeModal={() => setDeleteId()}
                            deleteId={deleteId}
                            deleteHandler={deleteHandler}
                            
                        />
                    </header>
                    <table className="table table-sm categories-table">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">نام دسته بندی</th>
                                <th scope="col">ویرایش / حذف</th>
                                {/* <th scope="col">Handle</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                placeCategories.map( (item, index) => 
                                    <tr key={item._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{item.title}</td>
                                        <td>
                                            <button className="btn btn-primary btn-sm rounded-pill"
                                                onClick={() => history.push('/dashboard/editplacecategory',
                                                { name: item.title, _id: item._id}
                                                )}
                                            >
                                                ویرایش
                                            </button>
                                            <button className="btn btn-danger btn-sm rounded-pill"
                                                onClick={() => setDeleteId(item._id)}
                                            >
                                                حذف
                                            </button>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    <section className="insert-category">
                        <button className="btn btn-success"
                            onClick= {() => history.push('/dashboard/newplacecategory')}
                        >
                            <i className="fa fa-plus"></i>
                            دسته بندی جدید
                        </button>
                    </section>
                </div>
            }
        </React.Fragment>
    );
};

export default PlaceCategories;
